import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosError } from 'axios';

import { ActionRequest } from '@models/ActionRequest';
import { ActionRequestApi } from '@apis/ActionRequestApi';
import { SagaPayload } from '@utils/typescript';
import { Pagination } from '@models/Pagination';
import { getResponseError } from '@utils/error';

import {
  actionRequestsFetch,
  ActionRequestsFetchPayload,
  actionRequestCreate,
  ActionRequestCreatePayload,
  actionRequestUpdate,
  ActionRequestUpdatePayload,
  stateUpdate,
  StateUpdatePayload,
  stateReload,
} from './action';

function* handleActionRequestsFetch({ payload }: SagaPayload<ActionRequestsFetchPayload>) {
  const state: StateUpdatePayload = { actionRequests: null, pagination: undefined };
  try {
    const [actionRequests, pagination] = (yield call(ActionRequestApi.getAll, payload)) as [ActionRequest[], Pagination];
    state.actionRequests = actionRequests;
    state.pagination = pagination;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleActionRequestCreate({ payload }: SagaPayload<ActionRequestCreatePayload>) {
  try {
    yield call(ActionRequestApi.create, payload);
    yield put(stateReload());
    const state: StateUpdatePayload = { isSuccess: true, serverErrors: {} };
    yield put(stateUpdate(state));
  } catch (e) {
    const serverErrors = getResponseError(e as AxiosError).errors;
    const state: StateUpdatePayload = { isSuccess: false, serverErrors };
    yield put(stateUpdate(state));
  }
}

function* handleActionRequestUpdate({ payload }: SagaPayload<ActionRequestUpdatePayload>) {
  try {
    yield call(ActionRequestApi.update, payload);
    yield put(stateReload());
    const state: StateUpdatePayload = { isSuccess: true, serverErrors: {} };
    yield put(stateUpdate(state));
  } catch (e) {
    const serverErrors = getResponseError(e as AxiosError).errors;
    const state: StateUpdatePayload = { isSuccess: false, serverErrors };
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(actionRequestsFetch, handleActionRequestsFetch);
  yield takeLatest(actionRequestCreate, handleActionRequestCreate);
  yield takeLatest(actionRequestUpdate, handleActionRequestUpdate);
}
